export default {
  account: "",
  travel_features: "",
  summary: "",
  travel_habits: "",
  car_journeys: "",
  sustainable_travel: "",
  maps: "",
  heatmap: "",
  schools: "",
  edit_school: "",
  signups: "",
  councils: "",
  edit_council: "",
  noticeboard: "",
  create_post: "",
  pupils: "",
  parents: "",
  staff: "",
  actions: "Pooya forgot to give me description for pages, until then, this will do...",
  automations: "",
  step_actions: "Pooya forgot to give me description for pages, until then, this will do...",
  surveys: "",
  engagement: "",
  school_integrations: ""
};
